import React from 'react';

// components
import { FormButton } from '../ui/buttons/FormButton';
import {
  ModalContainer,
  ModalBody,
  ModalFooter,
  ModalFormContainer,
  ModalHeader,
  ModalHeaderInnerContainer,
  ModalHeaderMainText,
  ModalHeaderSecondaryText,
  ModalBoldText,
} from './modalComponents';
import ticketService from '../../ticketService';
import t from './TicketUpdateTranslations';
import ticketActions from '../../constants/ticketActions';
export const TicketUpdateError = ({ ticket, type, ok }) => {
  const formattedTicketId = ticketService.utils.getFormatedId(ticket.id);

  return (
    <ModalContainer>
      <ModalBody>
        <ModalHeader>
          <ModalHeaderInnerContainer>
            <ModalHeaderSecondaryText>{`Ticket ID. ${formattedTicketId}`}</ModalHeaderSecondaryText>
            {[
              ticketActions.ON_THE_WAY,
              ticketActions.DELAYED,
              ticketActions.DELIVERED,
              ticketActions.PICKUP,
            ].some((action) => action === type) && (
              <ModalHeaderMainText>
                {t.sendMessage}: {t[type]}
              </ModalHeaderMainText>
            )}
            {[ticketActions.LAUNCH_OFFER].some((action) => action === type) && (
              <ModalHeaderMainText>{t.launchOffer}</ModalHeaderMainText>
            )}
          </ModalHeaderInnerContainer>
        </ModalHeader>
        <ModalFormContainer>
          <ModalBoldText>{t.networkFailure}</ModalBoldText>
        </ModalFormContainer>
      </ModalBody>
      <ModalFooter>
        <FormButton onClick={() => ok()}>{t.back}</FormButton>
      </ModalFooter>
    </ModalContainer>
  );
};

export default TicketUpdateError;
